import Router from './rootRouterDev';

ReactDOM.render(
    <React.Fragment>
        <Router />
    </React.Fragment>,
    document.getElementById('cis-container')
);